import React,{ useState, useEffect } from "react";
import moment from "moment";
import { StylesTable, bgColor , borderColor } from "./styled";
import {AddBox,Memory,CheckCircleOutline,
  Filter1,
  Filter2,
  Filter3,
  Filter4,
  Filter5,
  Filter6,
  Filter7,
  Filter8,
  Filter9,
  Filter9Plus,
  Check
} from "@mui/icons-material";

const StatisticsTable = (props) => {
  return (
    <StylesTable className="table">
      <tr>
        <th
          style={{
            maxWidth: "120px",
          }}
        >
          <h3>{props?.name}</h3>
        </th>
        <th scope="col">VIC</th>
        <th scope="col">NSW</th>
        <th scope="col">QLD</th>
        <th scope="col">WA</th>
        <th scope="col">SA</th>
      </tr>
      <tr>
        <th scope="row">Total this month</th>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
      </tr>
      <tr>
        <th scope="row">Total last month</th>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
      </tr>
      <tr>
        <th scope="row">3 months</th>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
      </tr>
      <tr>
        <th scope="row">6 months</th>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
      </tr>
      <tr>
        <th scope="row">12 months</th>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
      </tr>
    </StylesTable>
  );
};

export function statTable(data){
  let head = [['Date','Booking','Hour','AM','Noon','PM','VIC','NSW','QLD','WA','SA']]
  let table = []
  let count = 7
  for(let date in data){
    table[count] = []
    table[count].push(moment(date).format('ddd D MMM'))
    for(let item in data[date]){
      table[count].push(data[date][item])
    }
    count--
  }
  table.sort((a, b) => moment(a[0], 'ddd D MMM').valueOf() - moment(b[0], 'ddd D MMM').valueOf());
  return (
    <StylesTable className="table"  style={{ textAlign: 'center' }}>
      {head.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <th key={itemIndex}
          style={{
            color: itemIndex >= 3 && itemIndex <= 5 ? borderColor[1] : null,
          }}
          >{item}</th>
        ))}
      </tr>
    ))}
      {table.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <td
          key={itemIndex}
          style={{
            color: itemIndex >= 3 && itemIndex <= 5 ? borderColor[1] : null,
          }}
        >
          {Math.round(item) ? Math.round(item) : item}
        </td>
        ))}
      </tr>
    ))}
    </StylesTable>
  );
}

export function tableMake(rawData,showTest,rowID,setRow,teacher,setTeacher,assignAI){
  let head = [['','','Institute','Campus','Day','Date','Time','Level','Preferred','Teachers']]
  if(rawData && Object.keys(rawData).length > 0){
    const data = rawData.summary
    const details = rawData.details;
    if(data === 'No bookings found' || (!showTest && data.filter(obj => 
      (obj.Institute === 'ReadyTeacherTest') ||
      (obj.Institute === 'ECEC Test')
      ).length == data.length )){
      return(
        <StylesTable className="table"  style={{ textAlign: 'center', color : '#000' }}>
          <tr><th
          className="bg-success"
          >No Bookings Found</th></tr>
        </StylesTable>
      )
    }else{
    data.sort((a, b) => {
      const dateA = new Date(a.Date);
      const dateB = new Date(b.Date);
      return dateA - dateB;
      });
      return (
        <StylesTable className="table"  style={{ textAlign: 'center', color : '#000' }}>
          {head.map((row, rowIndex) => (
          <tr key={rowIndex}
              className={'bg-info'}
          >
            {row.map((item, itemIndex) => (
              <th key={itemIndex}
              >{item}</th>
            ))}
          </tr>
        ))}
          {data.map((row, rowIndex) => (
            row.Institute != 'ReadyTeacherTest' && row.Institute != 'ECEC Test' ?
            <React.Fragment key={rowIndex}>
            <tr id={row.id}
                className={
                  row.Time === 'MorningET' && row.flag ? 'bg-danger' 
                  : row.Time === 'MorningET'  ? 'bg-warning' : 'bg-primary'
                }
            >
              <td>{
                details[row.id].length > 1
                ? <button onClick={()=>{setRow(row.id)}}>
                {rowCount(details[row.id].length)}
                </button>
                : <a>
                {rowCount(details[row.id].length)}
                </a>
                }
              </td>
              <td>{<button 
              onClick={()=>{assignAI(row.id)}} 
              ><Memory sx={{ color: "#000" }}/></button>}</td>
              <td>{row.Institute}</td>
              <td>{row.Campus}</td>
              <td>{moment(row.Date).format("ddd")}</td>
              <td>{moment(row.Date).format("DD MMM")}</td>
              <td>{row.Time}</td>
              <td>{row.Level}</td>
              <td>
                {row.Teachers.map(teacher => (
                  teacher.preferred === 100 && (
                    <span key={teacher.id}
                    title={titleMake(teacher)}
                    className={`${
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available === 100 ? 'success' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available === 100 ? 'purple' :
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available !== 100 ? 'warning' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available !== 100 ? 'danger' :
                      teacher.blocked === 100 ? 'bg-secondary' :
                      null
                    } font-bold`}
                    >
                      {teacher.Name}
                    </span>
                  )
                ))}
                </td>
              <td>
                <select value={teacher} onChange={(event) => setTeacher(event.target.value, row.Institute)}>
                  <option value="">---</option>
                  {row.Teachers.map((teacher, teacherIndex) => (
                    <option 
                    key={teacherIndex} 
                    value={teacher.Name}
                    title={titleMake(teacher)}
                    className={
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available === 100 ? 'bg-success' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available === 100 ? 'bg-purple' :
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available !== 100 ? 'bg-warning' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available !== 100 ? 'bg-danger' :
                      teacher.blocked === 100 ? 'bg-secondary' :
                      null
                    }                    
                    >
                      {Math.round(teacher.Total_score)} - {teacher.Name}
                    </option>
                  )
                  )}
                </select>
              </td>
            </tr>
            {rowID === row.id && details[rowID] ?
            details[rowID].map((det, detIndex) => (
                <tr key={detIndex}
                    className={
                      Object.values(det.teachers).some(teacherObj => teacherObj.name === teacher) ? 'success' : null
                    }
                >
                  <td></td>
                  <td></td>
                  <td>{det.institute}</td>
                  <td>{det.campus}</td>
                  <td>{moment(det.date).format("ddd")}</td>
                  <td>{moment(det.date).format("DD MMM")}</td>
                  <td>{det.time}</td>
                  <td>{det.level}</td>
                  <td>
                    {Object.values(det.teachers).map(teacher => (
                      teacher.preferred === 100 && (
                        <span key={teacher.id}>
                          {teacher.Name}
                        </span>
                      )
                    ))}
                  </td>
                  <td>{
                    Object.values(det.teachers).some(teacherObj => teacherObj.name === teacher) ? <CheckCircleOutline/> : null
                    }</td>
                </tr>
              )) : null}
            </React.Fragment>
            : showTest ?
            <React.Fragment key={rowIndex}>
            <tr id={row.id}
                className={
                  row.Time === 'MorningET' && row.flag ? 'bg-danger'
                  : row.Time === 'MorningET' ? 'bg-warning' : 'bg-secondary'
                }
            >
              <td>{
                details[row.id].length > 1
                ? <button onClick={()=>{setRow(row.id)}}>
                {rowCount(details[row.id].length)}
                </button>
                : <a>
                {rowCount(details[row.id].length)}
                </a>
                }
              </td>
              <td>{<button 
              onClick={()=>{assignAI(row.id)}} 
              ><Memory sx={{ color: "#000" }}/></button>}</td>
              <td>{row.Institute}</td>
              <td>{row.Campus}</td>
              <td>{moment(row.Date).format("ddd")}</td>
              <td>{moment(row.Date).format("DD MMM")}</td>
              <td>{row.Time}</td>
              <td>{row.Level}</td>
              <td>
                {row.Teachers.map(teacher => (
                  teacher.preferred === 100 && (
                    <span key={teacher.id}
                    className={
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available === 100 ? 'success' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available === 100 ? 'purple' :
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available !== 100 ? 'warning' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available !== 100 ? 'danger' :
                      teacher.blocked === 100 ? 'bg-secondary' :
                      null
                    }  
                    >
                      {teacher.Name}
                      {teacher.status ? <p className="text-dark">{teacher.status}</p> : ''}
                    </span>
                  )
                ))}
                </td>
              <td>
                <select value={teacher} onChange={(event) => setTeacher(event.target.value, row.Institute)}>
                  <option value="">---</option>
                  {row.Teachers.map((teacher, teacherIndex) => (
                    <option 
                    key={teacherIndex} 
                    value={teacher.Name}
                    title={titleMake(teacher)}
                    className={
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available === 100 ? 'bg-success' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available === 100 ? 'bg-purple' :
                      teacher.preferred === 100 && teacher.canDeliver && teacher.available !== 100 ? 'bg-warning' :
                      teacher.preferred === 100 && !teacher.canDeliver && teacher.available !== 100 ? 'bg-danger' :
                      teacher.blocked === 100 ? 'bg-secondary' :
                      null
                    }    
                    >
                      {Math.round(teacher.Total_score)} - {teacher.Name} {teacher.status ? ' - ' + teacher.status : ''}
                    </option>
                  )
                  )}
                </select>
              </td>
            </tr>
            {rowID === row.id && details[rowID] ?
            details[rowID].map((det, detIndex) => (
                <tr key={detIndex}
                    className={
                      Object.values(det.teachers).some(teacherObj => teacherObj.name === teacher) ? 'success' : null
                    }
                >
                  <td></td>
                  <td></td>
                  <td>{det.institute}</td>
                  <td>{det.campus}</td>
                  <td>{moment(det.date).format("ddd")}</td>
                  <td>{moment(det.date).format("DD MMM")}</td>
                  <td>{det.time}</td>
                  <td>{det.level}</td>
                  <td>
                    {Object.values(det.teachers).map(teacher => (
                      teacher.preferred === 100 && (
                        <span key={teacher.id}>
                          {teacher.Name}
                        </span>
                      )
                    ))}
                  </td>
                  <td>{
                    Object.values(det.teachers).some(teacherObj => teacherObj.name === teacher) ? <CheckCircleOutline/> : null
                    }</td>
                </tr>
              )) : null}
            </React.Fragment>
            : null
          )
          )}
        </StylesTable>
      );
    }
  }
}
const titleMake = (teacher) => {
  let dist = "very close to";
  if (teacher.distance >= 75 && teacher.distance < 100) {
    dist = "Close to";
  }
  if (teacher.distance > 50 && teacher.distance < 75) {
    dist = "not that far from";
  }
  if (teacher.distance <= 50) {
    dist = "Far from";
  }
  const title = `Covers ${teacher.available} % of the booking
Lives ${dist} the campus
${teacher.senior == 100 ? "Senior" : "Junior"}
${teacher.last == 100 ? "Pre taught this booking" : ""}
${teacher.inst == 100 ? "Been to this Campus before" : ""}
${teacher.preferred == 100 ? "Preferred teacher" : ""}
${teacher.available !== 100 ? "NOT Available" : "Available"}
${!teacher.canDeliver? "Misses CanDeliver" : "canDeliver"}
${teacher.favorite == 100 ? "Favorite teacher" : ""}
${teacher.block == 100 ? "Block-Listed" : ""}
    `;
  return title;
};
const rowCount = (count) =>{
  return count == 1
  ? <Filter1 sx={{ color: "#000" }}/>
  : count == 2 ? <Filter2 sx={{ color: "#000" }}/>
  : count == 3 ? <Filter3 sx={{ color: "#000" }}/>
  : count == 4 ? <Filter4 sx={{ color: "#000" }}/>
  : count == 5 ? <Filter5 sx={{ color: "#000" }}/>
  : count == 6 ? <Filter6 sx={{ color: "#000" }}/>
  : count == 7 ? <Filter7 sx={{ color: "#000" }}/>
  : count == 8 ? <Filter8 sx={{ color: "#000" }}/>
  : count == 9 ? <Filter9 sx={{ color: "#000" }}/>
  : <Filter9Plus sx={{ color: "#000" }}/>
}
const addrows = (details) => {

}
export function newRegTable(data,updateCheckbox,type){
  let head = [['','Date','Name','State','Phone','Email','Verified','Emailed','Call','SMS']]
  const title = []
  let table = []
  if(data.length >0){
    data.sort((a, b) => new Date(a.registration_date) - new Date(b.registration_date));
  for(let item of data){
    const tType = item.is_elt && item.is_vet ? 'ELICOS/VET' 
                : item.is_elt ? 'ELICOS'
                : item.is_childhood_teacher ? 'ECEC'
                : 'VET'
    if(tType === type || (tType === 'ELICOS/VET' && type != 'ECEC')){
      table.push([
        tType,item.registration_date,item.name,item.state||'--',item.contact_number,item.email,
        item.email_verification_status,item.emailed,item.call,item.sms,//item._id
      ])
      title.push({
        email : item.emailedNote,
        call : item.callNote,
        sms : item.smsdNote
      })
    }
  }
  return (
    <StylesTable className="table"  style={{ textAlign: 'left' }}>
      {head.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <th key={itemIndex}
          style={{
            color: itemIndex >= 7 
            ? borderColor[1]
            : itemIndex == 6 ? borderColor[3] : null
            ,textAlign: itemIndex >= 6 ? 'center' : 'left'
          }}
          >{item}</th>
        ))}
      </tr>
    ))}
      {table.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <td
          key={itemIndex}
          style={{
            color: itemIndex >= 7 
            ? borderColor[1]
            : itemIndex == 6 ? borderColor[3] : null
            ,textAlign: itemIndex >= 6 ? 'center' : 'left'
          }}
          title = {
            itemIndex == 9
            ? title[rowIndex].sms
            :itemIndex == 8
            ? title[rowIndex].call
            :itemIndex == 7
            ? title[rowIndex].email
            : null
          }
        >
          { itemIndex === 6 && item === true 
          ? <Check/> 
          // : itemIndex > 5 && itemIndex != 9 ? (
          //   <input
          //     type="checkbox"
          //     checked={item}
          //     onChange={(e) => updateCheckbox(row[9], e.target.checked,itemIndex)} // Handle checkbox change
          //   />
          // ) 
          : itemIndex == 2 
          ? item.split('T')[0]
          : itemIndex > 6 && item
          ? moment(item).format('DD-MM-YYYY HH:mm:ss')
          : itemIndex == 10 ? null : item
          }
        </td>
        ))}
      </tr>
    ))}
    </StylesTable>
  );
  }
}
export function morningSummary(data,select,state){
  let head = [['State','ELCIOS','VET','ECEC']]
  if(data?.status?.includes('CLOSED')){
    return (
      <StylesTable className="table"    style={{ textAlign: 'center', color : '#000' }}>
        <tr>
      <th colSpan="2">
        System is CLOSED!
      </th>
    </tr>
    <tr>
      <td>
        Opens in:
      </td>
      <td>
        {data.opens_in}
      </td>
    </tr>
      </StylesTable>
    )
  }else{
  delete data.status
  delete data.Date
  delete data.summary
  delete data.opens_in
  const tableData = data.summarybyState || {}
    const keys = Object.keys(tableData);
    let table = keys.map(key => [key, ...tableData[key]]);
    table = table.sort((a, b) => b[1] - a[1]);
    if(table.length > 0) {
  return (
    <StylesTable className="table"    style={{ textAlign: 'center', color : '#000' }}>
      {head.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      className={'bg-info'}
      >
        {row.map((item, itemIndex) => (
          <th key={itemIndex}>{item}</th>
        ))}
      </tr>
    ))}
      {table.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      onClick={()=>{select(row[0])}}
      style={{ cursor: 'pointer' }}
      className={row[0] === state ? 'bg-success' : null} 
      >
        {row.map((item, itemIndex) => (
          <td 
          key={itemIndex}
          style={{ color: row[0] === state ? 'orange' : 'inherit',
                   fontWeight: itemIndex === 0 ? 'bold' : 'normal', }}
          >{item}</td>
        ))}
      </tr>
    ))}
    </StylesTable>
  );
  }
  }
}
export function morningTable(data){
  let head = [['State',	'Suburb',	'Name',	'Phone',	'Level', 'type',	'Address',	'Distance']]
  let table = []
  if(Object.keys(data).length > 0){
    table = data.map((obj) => head[0].map((key) => obj[key.toLowerCase()]));
  return (
    <StylesTable className="table"  style={{ textAlign: 'center', color : '#000' }}>
      {head.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      className={'bg-info'}
      >
        {row.map((item, itemIndex) => (
          <th key={itemIndex}>{
            item == 'Distance' ? 'Distance(Minutes)' : item
            }</th>
        ))}
      </tr>
    ))}
      {table.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      className={data[rowIndex].et ? 'bg-success' : ''}
      >
        {row.map((item, itemIndex) => (
          <td key={itemIndex}>{item}</td>
        ))}
      </tr>
    ))}
    </StylesTable>
  );
}
}

export function availableTable (data){
  let head = [['Type','Time']]
  let table = [
    ['ELICOS','AM'],
    ['ELICOS','PM'],
    ['VET','AM'],
    ['VET','PM'],
    ['ECEC','AM'],
    ['ECEC','PM'],
  ]
  for(let state in data){
    const states = state == 'All' ? 'unknown' : state
    head[0] = [...head[0],states]
    table[0] = [...table[0],data[state].ELICOS.AM]
    table[1] = [...table[1],data[state].ELICOS.PM]
    table[2] = [...table[2],data[state].VET.AM]
    table[3] = [...table[3],data[state].VET.PM]
    table[4] = [...table[4],data[state].ECEC.AM]
    table[5] = [...table[5],data[state].ECEC.PM]
  }
  return (
    <StylesTable className="table"  style={{ textAlign: 'center' }}>
      <tr>
        <th colSpan={head[0].length}
        style={{ color: borderColor[3]}}
        >
          Available Teachers
        </th>
      </tr>
      {head.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <th key={itemIndex}
          >{item}</th>
        ))}
      </tr>
    ))}
      {table.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((item, itemIndex) => (
          <td
          key={itemIndex}
        >
          {item}
        </td>
        ))}
      </tr>
    ))}
    </StylesTable>
  );
}

export function managerBookingTable (data,period){
  const states = ['VIC','NSW','QLD','WA','ACT','SA','NT','noState']
  let head = [['', 'Total' , ...states]]
  if(Object.keys(data).length > 0){
  return (
    <StylesTable className="table"  style={{ textAlign: 'center', color : '#000' }}>
      <tr className={'bg-info'}><th colSpan={10}>Booking</th></tr>
      {head.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      >
        {row.map((item, itemIndex) => (
          <th key={itemIndex}>{item}</th>
        ))}
      </tr>
    ))}
    <tr>
      <th>This {period}</th>
      <th>{data.week.this.count}</th>
      {states.map(state => (
        <td key={state}>{data.week.this.states[state] ? data.week.this.states[state] : 0}</td>
      ))}
    </tr>
    <tr>
      <th>Last {period}</th>
      <th>{data.week.past.count}
        <span className={data.week.variation.All > 0 ? 'success' : 'danger'}> ({data.week.variation.All}%)</span>
      </th>
      {states.map(state => (
        <td key={state}>{data.week.past.states[state] ? data.week.past.states[state] : 0}
        <span className={data.week.variation[state] > 0 ? 'success' : 'danger'}> ({data.week.variation[state] || 0}%)</span>
        </td>
      ))}
    </tr>
    <tr>
      <th>Same {period} Last Month</th>
      <th>{data.month.past.count}
        <span className={data.month.variation.All > 0 ? 'success' : 'danger'}> ({data.month.variation.All}%)</span>
      </th>
      {states.map(state => (
        <td key={state}>{data.month.past.states[state] ? data.month.past.states[state] : 0} 
        <span className={data.month.variation[state] > 0 ? 'success' : 'danger'}> ({data.month.variation[state] || 0}%)</span>
        </td>
      ))}
      
    </tr>
    </StylesTable>
  );
  }
}
export function managerRegTable (data){
  const states = ['VIC','NSW','QLD','WA','ACT','SA','NT','noState']
  let head = [['', 'Total' , ...states]]
  if(Object.keys(data).length > 0){
  return (
    <StylesTable className="table"  style={{ textAlign: 'center', color : '#000' }}>
      <tr className={'bg-info'}><th colSpan={10}>Registration</th></tr>
      {head.map((row, rowIndex) => (
      <tr 
      key={rowIndex}
      >
        {row.map((item, itemIndex) => (
          <th key={itemIndex}>{item}</th>
        ))}
      </tr>
    ))}
    <tr>
      <th>New Customers</th>
      <th>{data['new customer'].all}</th>
      {states.map(state => (
        <td key={state}>{data['new customer'].states[state] ? data['new customer'].states[state] : 0}</td>
      ))}
    </tr>
    <tr>
      <th>New Teachers</th>
      <th>{data['new teachers'].all}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].states[state] ? data['new teachers'].states[state] : 0}</td>
      ))}
    </tr>
    <tr>
      <th>Teachers Contacted</th>
      <th>--</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process.contact[state] ? data['new teachers'].process.contact[state] : 0} 
        </td>
      ))}
    </tr>
    <tr>
      <th>Teachers Onboarding</th>
      <th>{Object.values(data['new teachers'].process?.onboarding).reduce((acc, value) => acc + value, 0)}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process.onboarding[state] ? data['new teachers'].process.onboarding[state] : 0} 
        </td>
      ))}
    </tr>
    <tr>
      <th>Positive Feedback</th>
      <th>{Object.values(data['new teachers'].process['Positive Feedback']).reduce((acc, value) => acc + value, 0)}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process['Positive Feedback'][state] ? data['new teachers'].process['Positive Feedback'][state] : 0} 
        </td>
      ))}
    </tr>
    <tr>
      <th>Negative Feedback</th>
      <th>{Object.values(data['new teachers'].process['Negative Feedback']).reduce((acc, value) => acc + value, 0)}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process['Negative Feedback'][state] ? data['new teachers'].process['Negative Feedback'][state] : 0} 
        </td>
      ))}
    </tr>
    <tr>
      <th>Awarded Badges</th>
      <th>{data['new teachers'].process.badges.total}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process.badges[state] ? data['new teachers'].process.badges[state] : 0} 
        </td>
      ))}
    </tr>
    <tr>
      <th>Ended Employee Trial</th>
      <th>{Object.values(data['new teachers'].process['Employee']).reduce((acc, value) => acc + value, 0)}</th>
      {states.map(state => (
        <td key={state}>{data['new teachers'].process['Employee'][state] ? data['new teachers'].process['Employee'][state] : 0} 
        </td>
      ))}
      
    </tr>
    </StylesTable>
  );
  }
}

export default StatisticsTable;
